import Api from "../axios";

export const getEmployeeUnderManager = async (status) => {
  return await Api.get(`/employees_under_manager?status=${status}`);
};
